module.exports = __webpack_public_path__ + "static/media/twinkle-twinkle-little-star-mozart.7a6dc8e6.mp3";